<template>
  <exchange-log
    :exchanges="exchanges"
    :loading="loading"
    :loaded="loaded"
    title="Запросы к Bakai по этому заказу"
    empty-hint="Переписки нет. Она пишется, только когда включена настройка «Записывать переписку с Bakai» в системных настройках, на вкладке Bakai."
    @refresh="refresh"
  ></exchange-log>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ExchangeLog from '@/components/exchange-log.vue'

export default {
  name: 'OrderBakaiLog',
  components: { ExchangeLog },
  computed: {
    ...mapState('orderBakaiLog', ['exchanges', 'loading', 'loaded']),
  },
  async mounted() {
    await this.refresh()
  },
  methods: {
    ...mapActions('orderBakaiLog', ['fetchLog']),
    async refresh() {
      const { id } = this.$route.params
      await this.fetchLog(id)
    },
  },
}
</script>
